export default "__VITE_ASSET__BUX3UwfO__"